import { render, staticRenderFns } from "./TabsNav.vue?vue&type=template&id=11fadc3f&scoped=true"
import script from "./TabsNav.vue?vue&type=script&lang=js"
export * from "./TabsNav.vue?vue&type=script&lang=js"
import style0 from "./TabsNav.vue?vue&type=style&index=0&id=11fadc3f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11fadc3f",
  null
  
)

export default component.exports